import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AdminUsersTab from "./Admins/AdminUsersTab";
import CleaningStaffTab from "./CleaningStaffTab/CleaningStaffTab";
import PropertyManagersTab from "./PropertyManagers/PropertyManagersTab";
import PropertyOwnersTab from "./PropertyOwners/PropertyOwnersTab";

const UserManagementTabs = () => (
  <Tabs defaultValue="admins" className="w-full">
    <TabsList className="flex w-fit flex-wrap">
      <TabsTrigger value="admins">Administradores</TabsTrigger>
      <TabsTrigger value="owners">Propietarios</TabsTrigger>
      <TabsTrigger value="managers">Administradores de Propiedades</TabsTrigger>
      <TabsTrigger value="cleaning">Personal de Limpieza</TabsTrigger>
    </TabsList>

    <TabsContent value="admins" className="mt-6">
      <AdminUsersTab />
    </TabsContent>

    <TabsContent value="owners" className="mt-6">
      <PropertyOwnersTab />
    </TabsContent>

    <TabsContent value="managers" className="mt-6">
      <PropertyManagersTab />
    </TabsContent>

    <TabsContent value="cleaning" className="mt-6">
      <CleaningStaffTab />
    </TabsContent>
  </Tabs>
);

export default UserManagementTabs;
